import { DeweySchema } from "../helpers/brandSchema.ts";
import { colors } from "chameleonjs";
import { createStyleNode } from "../../../common/utils/style.ts";

function getStyles(colorName: string, identifier: string) {
  const color = colors[colorName];
  let styleString = "";
  if (color) {
    for (let i = 1; i <= 10; i++) {
      const shade = color.getShade(i);
      if (shade) {
        styleString += `--vst-${identifier}-${i}: ${shade};`;
      }
    }
    // These need to be redefined for .theme-accent to work. Variable reference
    // resolution is scope-dependent so won't update.
    styleString += `--vst-${identifier}-main: ${color.getShade(6)};`;
    styleString += `--vst-${identifier}-text: ${color.getShade(7)};`;
    styleString += `--vst-${identifier}-main-50: ${color.getShade(6)}80;`;
  }
  return styleString;
}

export function initTheme(theme: Omit<DeweySchema["Theme"], "secondary">) {
  const styleNode = createStyleNode("dewey-theme");
  const styleString =
    getStyles(theme.primary, "theme") + getStyles(theme.base, "accent");
  styleNode.innerText = `:root { ${styleString} }`;

  const accentAsTheme = getStyles(theme.base, "theme");
  styleNode.innerText += ` .theme-accent { ${accentAsTheme} }`;
}
